import { render, staticRenderFns } from "./ScrollBoxMobile.vue?vue&type=template&id=7825beb4&scoped=true"
import script from "./ScrollBoxMobile.vue?vue&type=script&lang=js"
export * from "./ScrollBoxMobile.vue?vue&type=script&lang=js"
import style0 from "./ScrollBoxMobile.vue?vue&type=style&index=0&id=7825beb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825beb4",
  null
  
)

export default component.exports